export default "__VITE_ASSET__4e640f99__"